import React from "react";
import SignIn from "./SignIn/SignIn";

const SignInPage = () => {
  return <SignIn />;
};

export default SignInPage;
